import React, { FunctionComponent, ReactNode } from 'react';
import * as s from './headline.module.scss';
import { IHeading } from '@/types';
// test

function getTag({
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  newHeading,
}: {
  h1?: boolean;
  h2?: boolean;
  h3?: boolean;
  h4?: boolean;
  h5?: boolean;
  h6?: boolean;
  newHeading?: IHeading | null;
}) {
  if (newHeading) {
    switch (newHeading?.variant?.__typename) {
      case 'DatoCmsH1':
        return 'h1';
      case 'DatoCmsH2':
        return 'h2';
      case 'DatoCmsH3ToH6':
        return newHeading?.variant?.tag ?? 'h3';
      default:
        return 'h1';
    }
  } else if (h6) return 'h6';
  else if (h5) return 'h5';
  else if (h4) return 'h4';
  else if (h3) return 'h3';
  else if (h2) return 'h2';
  else if (h1) return 'h1';
  else return 'h1';
}

export interface IHeadlineStyles {
  headline?: string | null;
  h1?: string | null;
  h2?: string | null;
  h3?: string | null;
  h4?: string | null;
  h5?: string | null;
  h6?: string | null;
  primary?: string | null;
  secondary?: string | null;
  tertiary?: string | null;
  white?: string | null;
  text?: string | null;
  center?: string | null;
  centerMobile?: string | null;
  black?: string | null;
}

export interface IHeadline extends React.HTMLAttributes<HTMLHeadingElement> {
  // props?: unknown;
  h1?: boolean;
  h2?: boolean;
  h3?: boolean;
  h4?: boolean;
  h5?: boolean;
  h6?: boolean;
  html?: string | null;
  children?: ReactNode;
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  white?: boolean;
  text?: boolean;
  center?: boolean;
  centerMobile?: boolean;
  className?: string;
  styles?: IHeadlineStyles | null;
  heroHeadline?: boolean;
  ref?: React.LegacyRef<HTMLHeadingElement>;
  newStyle?: boolean;
  newHeading?: IHeading | null;
  black?: boolean;
}

const Headline: FunctionComponent<IHeadline> = ({
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  html,
  children,
  primary,
  secondary,
  tertiary,
  white,
  black,
  text,
  center,
  centerMobile,
  className,
  heroHeadline,
  styles,
  ref,
  newStyle,
  newHeading,
  ...props
}) => {
  if (!children && !html && !newHeading) return null;

  const Tag = getTag({ h1, h2, h3, h4, h5, h6, newHeading });
  // classes
  const primaryClass = newHeading?.color === 'gold' || primary ? styles?.primary || s.primary : '';
  const secondaryClass = secondary ? styles?.secondary || s.secondary : '';
  const tertiaryClass = tertiary ? styles?.tertiary || s.tertiary : '';
  const textClass = newHeading?.color === 'gray' || text ? styles?.text || s.text : '';
  const whiteClass = newHeading?.color === 'white' || white ? styles?.white || s.white : '';
  const blackClass = newHeading?.color === 'black' || black ? styles?.black || s.black : '';

  let colorClass;
  switch (newHeading?.color) {
    case undefined:
      colorClass = primaryClass || secondaryClass || tertiaryClass || whiteClass || textClass || blackClass;
      break;
    case 'default':
      colorClass = primaryClass || secondaryClass || tertiaryClass || whiteClass || textClass || blackClass;
      break;
    case 'gold':
      colorClass = primaryClass;
      break;
    case 'black':
      colorClass = blackClass;
      break;
    case 'white':
      colorClass = whiteClass;
      break;
    case 'gray':
      colorClass = textClass;
      break;
  }

  const tagClasss = (heroHeadline && styles?.['h1']) || styles?.[Tag] || s[Tag] || '';

  const centerClass = newHeading?.center || center ? styles?.center || s.center : '';
  const centerMobileClass = newHeading?.centerMobile || centerMobile ? styles?.centerMobile || s.centerMobile : '';
  const alignmentClass = centerClass || centerMobileClass;

  const classes = `${styles?.headline || s.headline} ${colorClass} ${alignmentClass} ${tagClasss} ${className}`;

  if (newHeading || html) {
    return (
      <Tag
        ref={ref}
        {...props}
        className={classes}
        dangerouslySetInnerHTML={{ __html: newHeading?.variant?.text || newHeading?.variant?.html || html || '' }}
      />
    );
  } else {
    return (
      <Tag {...props} ref={ref} className={classes}>
        {children}
      </Tag>
    );
  }
};

export default React.memo(Headline);
